/** Shared status→chip-color helpers for the Loan Review tab (avoids circular imports between Hero/Sections/ServiceTable). */
import type { LoanReviewPipelineStage } from '../../lib/loanReview/mapLoanReviewToViewModel';

export type ChipColor = 'default' | 'success' | 'warning' | 'error';

export function statusChipColor(status: string): ChipColor {
  const s = status.toUpperCase();
  if (s === 'PASS' || s === 'SKIPPED') return 'success';
  if (s === 'PASS_WITH_VARIATION' || s === 'REVIEW') return 'warning';
  if (s === 'FAIL' || s === 'ERROR' || s === 'UNAVAILABLE') return 'error';
  return 'default';
}

export function stageChipColor(status: LoanReviewPipelineStage['status']): ChipColor {
  switch (status) {
    case 'done':
      return 'success';
    case 'soft':
      return 'warning';
    case 'blocked':
      return 'error';
    default:
      return 'default';
  }
}

/** Worst-first summary chip for a section header, from a list of raw statuses. */
export function overallStatusMeta(statuses: string[]): { label: string; color: ChipColor } {
  const upper = statuses.map((s) => s.toUpperCase());
  if (upper.length === 0) return { label: 'No data', color: 'default' };
  if (upper.some((s) => ['FAIL', 'ERROR', 'UNAVAILABLE'].includes(s))) return { label: 'Blocked', color: 'error' };
  if (upper.some((s) => s === 'REVIEW')) return { label: 'Needs review', color: 'warning' };
  if (upper.some((s) => s === 'PASS_WITH_VARIATION')) return { label: 'Soft differences', color: 'warning' };
  return { label: 'All clear', color: 'success' };
}
